import React, { useEffect } from "react";

import { FooterAction } from "@/components/organisms/FooterAction";
import { useButtonObserver } from "@/hooks/useButtonObserver";
import { getProductOptions } from "@/utils/product";
import helpers from "@/utils/helpers";
import { DetailPlanMobile } from "../../../shared/components/DetailPlanMobile/index";

export const SectionAction = ({ analyticsDetailAction }) => {
  const { digitalDataProductName, productName } = getProductOptions();
  const isDisabled = useButtonObserver("btn-payment-vcd");

  const handleClick = () => {
    const element = document.getElementsByClassName("btn-payment-vcd");
    helpers.setActionTag({
      group: digitalDataProductName,
      category: "Resumen y pago",
      action: "click",
      label: "Pagar",
    });
    helpers.getTagVirtual(
      `sol:comprar:${productName}:loader-confirmacion`
    );
    element[0].click();
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        handleClick();
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <FooterAction
      textButton="Pagar"
      disabled={isDisabled}
      onHandleClick={handleClick}
      contentAdditional={<DetailPlanMobile shouldDisplayBeneficiaries callAnalyticsAction={analyticsDetailAction} />}
    />
  );
};
